export default "__VITE_ASSET__BmSPT$Pu__"